import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header pb-0" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_18 = {
  key: 1,
  class: "table-responsive table_style"
}
const _hoisted_19 = { class: "table table-striped table-hover align-middle" }
const _hoisted_20 = { class: "table-group-divider" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "badge bg-secondary" }
const _hoisted_23 = { class: "package-slug" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_25 = { class: "description-cell" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "form-check form-switch" }
const _hoisted_38 = ["checked", "onChange", "disabled"]
const _hoisted_39 = { class: "form-check-label text-xs" }
const _hoisted_40 = {
  class: "d-flex gap-2",
  role: "group"
}
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = ["onClick", "disabled"]
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = ["onClick", "disabled"]
const _hoisted_45 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center mt-4 pt-3 border-top"
}
const _hoisted_48 = { class: "text-muted" }
const _hoisted_49 = {
  key: 0,
  "aria-label": "Packages pagination"
}
const _hoisted_50 = { class: "pagination pagination-sm mb-0" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["onClick", "aria-label", "aria-current"]
const _hoisted_53 = {
  key: 1,
  class: "page-link"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 2,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_56 = { class: "modal-dialog modal-lg" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-body" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "table-responsive" }
const _hoisted_61 = { class: "table table-sm table-hover" }
const _hoisted_62 = { class: "text-muted" }
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_66 = {
  key: 1,
  class: "text-center py-3"
}
const _hoisted_67 = {
  key: 3,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_68 = { class: "modal-dialog modal-lg" }
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "table-responsive" }
const _hoisted_73 = { class: "table table-sm table-hover" }
const _hoisted_74 = { class: "badge bg-info" }
const _hoisted_75 = { class: "text-end" }
const _hoisted_76 = { class: "badge bg-primary" }
const _hoisted_77 = { class: "badge bg-secondary" }
const _hoisted_78 = { class: "text-end" }
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = {
  key: 1,
  class: "text-center py-3"
}

import { ref, computed, onMounted, defineAsyncComponent } from "vue";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'PackagesList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();

const PackageModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/PackageModal.vue")
);

const PackageViewModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/PackageViewModal.vue")
);

// State
const packages = ref<any[]>([]);
const categories = ref<any[]>([]);
const allFeatures = ref<any[]>([]);
const currencies = ref<any[]>([]);
const loading = ref(false);
const searchQuery = ref("");
const filterPackageType = ref("");
const filterStatus = ref("");
const filterVisibility = ref("");
const sortBy = ref("name");
const currentPage = ref(1);
const itemsPerPage = ref(10);
const totalItems = ref(0);

// Modal state
const showModal = ref(false);
const showViewModal = ref(false);
const showFeaturesModal = ref(false);
const showPricesModal = ref(false);
const selectedPackage = ref<any>(null);
const selectedFeatures = ref<any[]>([]);
const selectedPrices = ref<any[]>([]);
const isEditMode = ref(false);

// Computed
const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const startItem = computed(
  () => (currentPage.value - 1) * itemsPerPage.value + 1
);

const endItem = computed(() =>
  Math.min(currentPage.value * itemsPerPage.value, totalItems.value)
);

const visiblePages = computed(() => {
  const delta = 2;
  const range = [];
  const rangeWithDots = [];

  if (totalPages.value <= 1) {
    return [1];
  }

  if (totalPages.value <= 7) {
    for (let i = 1; i <= totalPages.value; i++) {
      range.push(i);
    }
    return range;
  }

  for (
    let i = Math.max(2, currentPage.value - delta);
    i <= Math.min(totalPages.value - 1, currentPage.value + delta);
    i++
  ) {
    range.push(i);
  }

  if (currentPage.value - delta > 2) {
    rangeWithDots.push(1, "...");
  } else {
    rangeWithDots.push(1);
  }

  rangeWithDots.push(...range);

  if (currentPage.value + delta < totalPages.value - 1) {
    rangeWithDots.push("...", totalPages.value);
  } else if (totalPages.value > 1) {
    rangeWithDots.push(totalPages.value);
  }

  return rangeWithDots.filter(
    (page, index, array) => array.indexOf(page) === index
  );
});

// Methods
const fetchPackages = async () => {
  try {
    loading.value = true;
    const params: any = {
      page: currentPage.value,
      limit: itemsPerPage.value,
    };

    if (searchQuery.value) {
      params.search = searchQuery.value;
    }

    if (filterPackageType.value) {
      params.packageType = filterPackageType.value;
    }

    if (filterStatus.value !== "") {
      params.isActive = filterStatus.value;
    }

    if (filterVisibility.value !== "") {
      params.isPublic = filterVisibility.value;
    }

    const response = await apiService.getPackages(params);

    // Handle the standardized response structure
    if (response?.packages) {
      packages.value = response.packages;
      totalItems.value =
        response.pagination?.totalItems || response.packages.length;
    } else if (response?.data?.packages) {
      packages.value = response.data.packages;
      totalItems.value =
        response.data.pagination?.totalItems || response.data.packages.length;
    } else if (Array.isArray(response)) {
      packages.value = response;
      totalItems.value = response.length;
    } else {
      packages.value = [];
      totalItems.value = 0;
    }
  } catch (error: any) {
    console.error("Error fetching packages:", error);

    let errorMessage = "Failed to load packages";
    if (error.response?.status === 401 || error.response?.status === 403) {
      errorMessage = "You are not authorized to view packages";
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    toast.error(errorMessage);
    packages.value = [];
  } finally {
    loading.value = false;
  }
};

const fetchCategories = async () => {
  try {
    const response = await apiService.getPackageCategories({ limit: 100 });
    if (response.data && response.data.categories) {
      categories.value = response.data.categories;
    } else if (response.categories) {
      categories.value = response.categories;
    } else {
      categories.value = response.data || response || [];
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};

const fetchFeatures = async () => {
  try {
    const response = await apiService.getFeatures({ limit: 1000 });
    if (response.data && response.data.features) {
      allFeatures.value = response.data.features;
    } else if (response.features) {
      allFeatures.value = response.features;
    } else {
      allFeatures.value = response.data || response || [];
    }
  } catch (error) {
    console.error("Error fetching features:", error);
  }
};

const fetchCurrencies = async () => {
  try {
    const response = await apiService.getCurrencies({ limit: 100 });
    if (response.data && response.data.currencies) {
      currencies.value = response.data.currencies;
    } else if (response.currencies) {
      currencies.value = response.currencies;
    } else {
      currencies.value = response.data || response || [];
    }
  } catch (error) {
    console.error("Error fetching currencies:", error);
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  fetchPackages();
};

const handleFilter = () => {
  currentPage.value = 1;
  fetchPackages();
};

const resetFilters = () => {
  searchQuery.value = "";
  filterPackageType.value = "";
  filterStatus.value = "";
  filterVisibility.value = "";
  sortBy.value = "name";
  currentPage.value = 1;
  fetchPackages();
};

const changePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    fetchPackages();
  }
};

const openCreateModal = () => {
  selectedPackage.value = null;
  isEditMode.value = false;
  showModal.value = true;
};

const editPackage = (packageItem: any) => {
  selectedPackage.value = { ...packageItem };
  isEditMode.value = true;
  showModal.value = true;
};

const viewPackage = (packageItem: any) => {
  selectedPackage.value = packageItem;
  showViewModal.value = true;
};

const duplicatePackage = async (packageItem: any) => {
  const slugSuffix = "-copy-" + Date.now();
  const duplicateData = {
    slug: packageItem.slug + slugSuffix,
    name: packageItem.name + " (Copy)",
  };

  try {
    await apiService.duplicatePackage(packageItem._id, duplicateData);
    await fetchPackages();
    toast.success("Package duplicated successfully");
  } catch (error: any) {
    console.error("Error duplicating package:", error);

    let errorMessage = "Failed to duplicate package";
    if (error.response?.status === 401 || error.response?.status === 403) {
      errorMessage = "You are not authorized to duplicate packages";
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    toast.error(errorMessage);
  }
};

const closeModal = () => {
  showModal.value = false;
  selectedPackage.value = null;
  isEditMode.value = false;
};

const closeViewModal = () => {
  showViewModal.value = false;
  selectedPackage.value = null;
};

const handleEditFromView = (packageItem: any) => {
  closeViewModal();
  editPackage(packageItem);
};

const handlePackageSaved = () => {
  fetchPackages();
  closeModal();
  toast.success(
    isEditMode.value
      ? "Package updated successfully"
      : "Package created successfully"
  );
};

const handleToggleStatus = (id: string, event: Event) => {
  const target = event.target as HTMLInputElement;
  toggleStatus(id, target.checked);
};

const toggleStatus = async (id: string, status: boolean) => {
  try {
    // Optimistic update
    const packageIndex = packages.value.findIndex((pkg) => pkg._id === id);
    if (packageIndex !== -1) {
      packages.value[packageIndex].isActive = status;
    }

    await apiService.togglePackageStatus(id);
    toast.success(
      `Package ${status ? "activated" : "deactivated"} successfully`
    );

    await fetchPackages();
  } catch (error: any) {
    console.error("Error toggling status:", error);

    let errorMessage = "Failed to update package status";
    if (error.response?.status === 401 || error.response?.status === 403) {
      errorMessage = "You are not authorized to perform this action";
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    toast.error(errorMessage);

    // Revert optimistic update
    const packageIndex = packages.value.findIndex((pkg) => pkg._id === id);
    if (packageIndex !== -1) {
      packages.value[packageIndex].isActive = !status;
    }
  }
};

const deletePackage = async (id: string) => {
  if (
    !confirm(
      "Are you sure you want to delete this package? This action cannot be undone."
    )
  ) {
    return;
  }

  try {
    await apiService.deletePackage(id);
    await fetchPackages();
    toast.success("Package deleted successfully");
  } catch (error: any) {
    console.error("Error deleting package:", error);

    let errorMessage = "Failed to delete package";
    if (error.response?.status === 401 || error.response?.status === 403) {
      errorMessage = "You are not authorized to delete packages";
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    toast.error(errorMessage);
  }
};

const showFeatures = (features: any[]) => {
  selectedFeatures.value = features;
  showFeaturesModal.value = true;
};

const closeFeaturesModal = () => {
  showFeaturesModal.value = false;
  selectedFeatures.value = [];
};

const showPrices = (prices: any[]) => {
  selectedPrices.value = prices;
  showPricesModal.value = true;
};

const closePricesModal = () => {
  showPricesModal.value = false;
  selectedPrices.value = [];
};

// Utility functions
const truncateText = (text: string, maxLength: number): string => {
  if (!text) return "-";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const getPackageTypeBadgeClass = (packageType: string): string => {
  const typeClasses: Record<string, string> = {
    free: "bg-success",
    starter: "bg-info",
    basic: "bg-info",
    professional: "bg-primary",
    enterprise: "bg-success text-white",
    custom: "bg-warning text-dark",
  };
  return typeClasses[packageType] || "bg-secondary";
};

const formatPackageType = (packageType: string): string => {
  return packageType.charAt(0).toUpperCase() + packageType.slice(1);
};

const getFeatureName = (feature: any): string => {
  // Handle both populated feature object and feature ID string
  if (typeof feature === "object" && feature !== null) {
    return feature.name || "Unknown Feature";
  } else if (typeof feature === "string") {
    const foundFeature = allFeatures.value.find((f) => f._id === feature);
    return foundFeature?.name || "Unknown Feature";
  }
  return "Unknown Feature";
};

const getCurrencyName = (currency: any): string => {
  // Handle both populated currency object and currency ID string
  if (typeof currency === "object" && currency !== null) {
    return currency.code || "Unknown Currency";
  } else if (typeof currency === "string") {
    const foundCurrency = currencies.value.find((c) => c._id === currency);
    return foundCurrency?.code || "Unknown Currency";
  }
  return "Unknown Currency";
};

const formatAmount = (amount: number, currency: any): string => {
  let symbol = "$";
  let decimalPlaces = 2;

  // Handle both populated currency object and currency ID string
  if (typeof currency === "object" && currency !== null) {
    symbol = currency.symbol || "$";
    decimalPlaces = currency.decimalPlaces || 2;
  } else if (typeof currency === "string") {
    const foundCurrency = currencies.value.find((c) => c._id === currency);
    symbol = foundCurrency?.symbol || "$";
    decimalPlaces = foundCurrency?.decimalPlaces || 2;
  }

  // Handle the case where amount might already be in the correct format
  const displayAmount = amount < 100 ? amount : amount / 100;
  return `${symbol}${displayAmount.toFixed(decimalPlaces)}`;
};

const formatInterval = (interval: string): string => {
  const intervals: Record<string, string> = {
    day: "Daily",
    week: "Weekly",
    month: "Monthly",
    year: "Yearly",
  };
  return intervals[interval] || interval;
};

const formatPriceModel = (priceModel: string): string => {
  const models: Record<string, string> = {
    flat: "Flat Rate",
    tiered: "Tiered",
    usage: "Usage-based",
    graduated: "Graduated",
  };
  return models[priceModel] || priceModel;
};

const formatLimitValue = (value: any): string => {
  if (value === -1) return "Unlimited";
  if (typeof value === "number") return value.toLocaleString();
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
};

const getFeatureLimits = (feature: any): Record<string, any> => {
  // Check if feature has limits directly (old format)
  if (feature.limits && typeof feature.limits === "object") {
    return feature.limits;
  }

  // Check if feature has populated featureId with limits (new format)
  if (
    feature.featureId &&
    typeof feature.featureId === "object" &&
    feature.featureId.limits
  ) {
    return feature.featureId.limits;
  }

  return {};
};

// Lifecycle
onMounted(async () => {
  await Promise.all([
    fetchCategories(),
    fetchFeatures(),
    fetchCurrencies(),
    fetchPackages(),
  ]);
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumbs, { title: "Packages" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "mb-0" }, [
                  _createElementVNode("i", { class: "fas fa-box me-2" }),
                  _createTextVNode(" Package Management ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: openCreateModal,
                    disabled: !_unref(canCreate)('packages')
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                    _createTextVNode(" Add Package ", -1)
                  ]))], 8, _hoisted_8)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fas fa-search" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Search packages...",
                      onInput: handleSearch
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterPackageType).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[10] || (_cache[10] = [
                    _createStaticVNode("<option value=\"\" data-v-6ff0c5ef>All Types</option><option value=\"free\" data-v-6ff0c5ef>Free</option><option value=\"starter\" data-v-6ff0c5ef>Starter</option><option value=\"professional\" data-v-6ff0c5ef>Professional</option><option value=\"enterprise\" data-v-6ff0c5ef>Enterprise</option><option value=\"custom\" data-v-6ff0c5ef>Custom</option>", 6)
                  ]))], 544), [
                    [_vModelSelect, filterPackageType.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterStatus).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "true" }, "Active", -1),
                    _createElementVNode("option", { value: "false" }, "Inactive", -1)
                  ]))], 544), [
                    [_vModelSelect, filterStatus.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterVisibility).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("option", { value: "" }, "All Visibility", -1),
                    _createElementVNode("option", { value: "true" }, "Public", -1),
                    _createElementVNode("option", { value: "false" }, "Private", -1)
                  ]))], 544), [
                    [_vModelSelect, filterVisibility.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sortBy).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[13] || (_cache[13] = [
                    _createStaticVNode("<option value=\"name\" data-v-6ff0c5ef>Name</option><option value=\"slug\" data-v-6ff0c5ef>Slug</option><option value=\"packageType\" data-v-6ff0c5ef>Type</option><option value=\"sortOrder\" data-v-6ff0c5ef>Sort Order</option><option value=\"createdAt\" data-v-6ff0c5ef>Created Date</option>", 5)
                  ]))], 544), [
                    [_vModelSelect, sortBy.value]
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary w-100",
                    onClick: resetFilters,
                    title: "Reset Filters"
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
                  ]))])
                ])
              ]),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ]))]))
                : (packages.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("table", _hoisted_19, [
                        _cache[22] || (_cache[22] = _createElementVNode("thead", { class: "table-dark" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Sr No"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Slug"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Name"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Description"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Type"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"130px"}
                            }, "Features"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"130px"}
                            }, "Prices"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Public"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Status"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"180px"}
                            }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (packageItem, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: packageItem._id
                            }, [
                              _createElementVNode("td", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("code", _hoisted_23, _toDisplayString(packageItem.slug), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(packageItem.name), 1),
                                  (packageItem.sortOrder !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Order: " + _toDisplayString(packageItem.sortOrder), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("span", {
                                    title: packageItem.description,
                                    class: "text-muted"
                                  }, _toDisplayString(truncateText(packageItem.description, 50)), 9, _hoisted_26)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                            getPackageTypeBadgeClass(packageItem.packageType)
                          , "badge"])
                                }, _toDisplayString(formatPackageType(packageItem.packageType)), 3)
                              ]),
                              _createElementVNode("td", _hoisted_27, [
                                (
                            packageItem.features &&
                            packageItem.features.length > 0
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-info",
                                        onClick: ($event: any) => (showFeatures(packageItem.features)),
                                        title: "View Features"
                                      }, [
                                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-puzzle-piece" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(packageItem.features.length), 1)
                                      ], 8, _hoisted_29)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                              ]),
                              _createElementVNode("td", _hoisted_31, [
                                (
                            packageItem.prices && packageItem.prices.length > 0
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-success",
                                        onClick: ($event: any) => (showPrices(packageItem.prices)),
                                        title: "View Prices"
                                      }, [
                                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-dollar-sign" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(packageItem.prices.length), 1)
                                      ], 8, _hoisted_33)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
                              ]),
                              _createElementVNode("td", _hoisted_35, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(
                            packageItem.isPublic
                              ? 'badge bg-success'
                              : 'badge bg-secondary'
                          )
                                }, _toDisplayString(packageItem.isPublic ? "Public" : "Private"), 3)
                              ]),
                              _createElementVNode("td", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: packageItem.isActive,
                                    onChange: ($event: any) => (
                              handleToggleStatus(packageItem._id, $event)
                            ),
                                    disabled: loading.value || !_unref(canUpdate)('packages')
                                  }, null, 40, _hoisted_38),
                                  _createElementVNode("label", _hoisted_39, _toDisplayString(packageItem.isActive ? "Active" : "Inactive"), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: ($event: any) => (viewPackage(packageItem)),
                                    title: "View",
                                    disabled: !_unref(canView)('packages')
                                  }, [...(_cache[18] || (_cache[18] = [
                                    _createElementVNode("i", { class: "fas fa-eye" }, null, -1)
                                  ]))], 8, _hoisted_41),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-success",
                                    onClick: ($event: any) => (editPackage(packageItem)),
                                    title: "Edit",
                                    disabled: !_unref(canUpdate)('packages')
                                  }, [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                  ]))], 8, _hoisted_42),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-warning",
                                    onClick: ($event: any) => (duplicatePackage(packageItem)),
                                    title: "Duplicate",
                                    disabled: !_unref(canCreate)('packages')
                                  }, [...(_cache[20] || (_cache[20] = [
                                    _createElementVNode("i", { class: "fas fa-copy" }, null, -1)
                                  ]))], 8, _hoisted_43),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event: any) => (deletePackage(packageItem._id)),
                                    title: "Delete",
                                    disabled: !_unref(canDelete)('packages')
                                  }, [...(_cache[21] || (_cache[21] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_44)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-box fa-3x text-muted mb-3" }, null, -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("h5", { class: "text-muted" }, "No packages found", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-muted" }, " Create your first package to get started. ", -1)),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openCreateModal,
                        disabled: !_unref(canCreate)('packages')
                      }, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                        _createTextVNode(" Add Package ", -1)
                      ]))], 8, _hoisted_46)
                    ])),
              (totalItems.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("small", null, " Showing " + _toDisplayString(startItem.value) + " to " + _toDisplayString(endItem.value) + " of " + _toDisplayString(totalItems.value) + " packages ", 1)
                    ]),
                    (totalPages.value > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_49, [
                          _createElementVNode("ul", _hoisted_50, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value <= 1 }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (changePage(currentPage.value - 1))),
                                disabled: currentPage.value <= 1,
                                "aria-label": "Previous page"
                              }, [...(_cache[27] || (_cache[27] = [
                                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
                                _createElementVNode("span", { class: "ms-1 d-none d-sm-inline" }, "Previous", -1)
                              ]))], 8, _hoisted_51)
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                              }, [
                                (typeof page === 'number')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "page-link",
                                      onClick: ($event: any) => (changePage(page)),
                                      "aria-label": `Go to page ${page}`,
                                      "aria-current": 
                          page === currentPage.value ? 'page' : undefined
                        
                                    }, _toDisplayString(page), 9, _hoisted_52))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(page), 1))
                              ], 2))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value >= totalPages.value }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (changePage(currentPage.value + 1))),
                                disabled: currentPage.value >= totalPages.value,
                                "aria-label": "Next page"
                              }, [...(_cache[28] || (_cache[28] = [
                                _createElementVNode("span", { class: "me-1 d-none d-sm-inline" }, "Next", -1),
                                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                              ]))], 8, _hoisted_54)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(PackageModal), {
          key: 0,
          show: showModal.value,
          package: selectedPackage.value,
          "is-edit": isEditMode.value,
          categories: categories.value,
          features: allFeatures.value,
          currencies: currencies.value,
          onClose: closeModal,
          onSaved: handlePackageSaved
        }, null, 8, ["show", "package", "is-edit", "categories", "features", "currencies"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(PackageViewModal), {
          key: 1,
          show: showViewModal.value,
          packageData: selectedPackage.value,
          categories: categories.value,
          features: allFeatures.value,
          currencies: currencies.value,
          onClose: closeViewModal,
          onEdit: handleEditFromView
        }, null, 8, ["show", "packageData", "categories", "features", "currencies"]))
      : _createCommentVNode("", true),
    (showFeaturesModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[29] || (_cache[29] = _createElementVNode("h5", { class: "modal-title" }, [
                  _createElementVNode("i", { class: "fas fa-puzzle-piece me-2" }),
                  _createTextVNode(" Package Features ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeFeaturesModal
                })
              ]),
              _createElementVNode("div", _hoisted_58, [
                (selectedFeatures.value && selectedFeatures.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("table", _hoisted_61, [
                          _cache[31] || (_cache[31] = _createElementVNode("thead", { class: "table-light" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Feature"),
                              _createElementVNode("th", { class: "text-center" }, "Status"),
                              _createElementVNode("th", null, "Limits")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFeatures.value, (feature) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: feature.featureId
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("strong", null, _toDisplayString(getFeatureName(feature.featureId)), 1),
                                    _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("small", _hoisted_62, _toDisplayString(typeof feature.featureId === "object"
                              ? feature.featureId.key
                              : feature.featureId), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_63, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(
                            feature.enabled
                              ? 'badge bg-success'
                              : 'badge bg-secondary'
                          )
                                  }, _toDisplayString(feature.enabled ? "Enabled" : "Disabled"), 3)
                                ]),
                                _createElementVNode("td", null, [
                                  (
                            getFeatureLimits(feature) &&
                            Object.keys(getFeatureLimits(feature)).length > 0
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFeatureLimits(feature), (value, key) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: String(key),
                                            class: "small"
                                          }, [
                                            _createElementVNode("code", null, _toDisplayString(key), 1),
                                            _createTextVNode(": " + _toDisplayString(formatLimitValue(value)), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_65, "No limits"))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_66, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("i", { class: "fas fa-puzzle-piece fa-2x text-muted mb-2" }, null, -1),
                      _createElementVNode("p", { class: "text-muted mb-0" }, "No features configured", -1)
                    ]))]))
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeFeaturesModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showPricesModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[33] || (_cache[33] = _createElementVNode("h5", { class: "modal-title" }, [
                  _createElementVNode("i", { class: "fas fa-dollar-sign me-2" }),
                  _createTextVNode(" Package Pricing ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closePricesModal
                })
              ]),
              _createElementVNode("div", _hoisted_70, [
                (selectedPrices.value && selectedPrices.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("table", _hoisted_73, [
                          _cache[34] || (_cache[34] = _createElementVNode("thead", { class: "table-light" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Currency"),
                              _createElementVNode("th", { class: "text-end" }, "Amount"),
                              _createElementVNode("th", null, "Interval"),
                              _createElementVNode("th", null, "Model"),
                              _createElementVNode("th", { class: "text-end" }, "Setup Fee"),
                              _createElementVNode("th", { class: "text-center" }, "Trial Days")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPrices.value, (price, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_74, _toDisplayString(getCurrencyName(price.currency)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_75, [
                                  _createElementVNode("strong", null, _toDisplayString(formatAmount(price.amount, price.currency)), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(formatInterval(price.interval)), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_77, _toDisplayString(formatPriceModel(price.priceModel)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_78, _toDisplayString(price.setupFee
                            ? formatAmount(price.setupFee, price.currency)
                            : "-"), 1),
                                _createElementVNode("td", _hoisted_79, _toDisplayString(price.trialDays || "-"), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_80, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("i", { class: "fas fa-dollar-sign fa-2x text-muted mb-2" }, null, -1),
                      _createElementVNode("p", { class: "text-muted mb-0" }, "No pricing configured", -1)
                    ]))]))
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closePricesModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})